import QuoteDescription from './QuoteDescription'


export default QuoteDescription
